import loadable from '@loadable/component';
import './BookingButtons.css';

export default loadable(() => {
  return import('./BookingButtons.jsx');
});
